import { ImgHTMLAttributes } from 'react';

interface OptimizedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  sizes?: string;
  priority?: boolean; // true para LCP images
}

export function OptimizedImage({
  src,
  alt,
  sizes,
  priority = false,
  className,
  ...props
}: OptimizedImageProps) {
  // Generar WebP y fallback paths
  const webpSrc = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  return (
    <picture>
      <source type="image/webp" srcSet={webpSrc} sizes={sizes} />
      <img
        src={src}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding={priority ? 'sync' : 'async'}
        className={className}
        {...props}
      />
    </picture>
  );
}
